import Handlebars from '@sparta.global.vendors/handlebars';

/* eslint-disable consistent-return */
/* eslint-disable import/prefer-default-export */

/**
 * @const STRINGS
 * @description constant for storing message strings
 */
const STRINGS = {
  NO_badge_JCR_ERROR: 'No badge or indicator JCR objects provided to helper-badging.'
};

/**
 * Default variables for the utility
 */
const DEFAULTS = new function defaultsSettingsConstructor() {
  // Class names and attributes
  this.preface = 'spa';
  this.component = 'badge';
  this.nameSpace = `${this.preface}-${this.component}`;
  this.numeric = `${this.nameSpace} ${this.nameSpace}--numeric`;
  this.dot = `${this.nameSpace} ${this.nameSpace}--dot`;
}();

/**
 * @method helpers.badgingHelper
 * @param {object} jcr JSON object used to build the badgeHelper.
 * @param {object} context JSON options object used to build the badgeHelper.
 * @returns {Node} `Handlebars.SafeString` version of the dom element.
 * @description This pieces together all the HTML elements needed
 */
function badgingHelper(jcr, context) {
  if (!jcr) {
    throw new Error(STRINGS.NO_badge_JCR_ERROR);
  }
  // Create settings object from JCR information.
  // ----------------------------------- //
  const optionsData = jcr;
  const settings = new function SettingsContructor() {
    this.class = [];
    this.numberValue = '';

    // Base
    this.getID = optionsData.id ? optionsData.id : '';

    // output
    this.output = '';

    // Badge attributes.
    this.id = optionsData.id ? `id='${this.getID.toLowerCase()}'` : '';
    this.badgeType = '';
    if (optionsData.type && optionsData.type === 'numeric') {
      if (optionsData.content && optionsData.content > 0) {
        this.badgeType = 'numeric';
      } else {
        this.badgeType = 'dot';
      }
    }

    // Depending on the type, add the class
    if (this.badgeType === 'numeric') {
      this.class.push(`${DEFAULTS.numeric}`);
    } else {
      this.class.push(`${DEFAULTS.dot}`);
    }
    if (optionsData.options.position) {
      this.class.push(`spa-badging-pos--${optionsData.options.position}`);
    } else {
      this.class.push('spa-badging-pos--relative');
    }
    if (optionsData.classNames) {
      this.class.push(`${optionsData.classNames}`);
    }

    // Create a list of attributes for the cms wrapper
    const {
      attributes = {}
    } = optionsData;
    this.attributesString = '';
    Object.keys(attributes).forEach(key => {
      if (typeof attributes[key] === 'string' || typeof attributes[key] === 'boolean') {
        this.attributesString += `${key}="${attributes[key]}"`;
      } else {
        this.attributesString += `${key}="${Handlebars.Utils.escapeExpression(JSON.stringify(attributes[key]))}"`;
      }
    });

    // Check for value
    if (this.badgeType === 'numeric') {
      if (optionsData.content && optionsData.content > 0) {
        if (optionsData.content > 99) {
          this.numberValue = '99+';
        } else {
          this.numberValue = Math.trunc(optionsData.content);
        }
      }
    }

    // ADA text
    this.ariaLabel = optionsData.options.ariaLabel ? `<span class="ada-hidden">${optionsData.options.ariaLabel}</span>` : '';

    // Create badge
    // ----------------------------------- //
    const classList = this.class.join(' ');
    this.output += `
    <span ${this.id} 
      class="${classList}" 
      ${this.attributesString}
    >${this.numberValue}
     ${this.ariaLabel}
    </span>
    `.trim();
  }();

  // return HTML to page
  // ----------------------------------- //
  return new Handlebars.SafeString(settings.output);
}

export { badgingHelper };
